import { IPriceConfigTab } from "@/store/pricesTabStore";
import React, {
  useState,
  ChangeEvent,
  KeyboardEvent,
  FocusEvent,
  useEffect,
} from "react";
import { toast } from "react-toastify";
import { IActiveTabData } from "./widgetsLayoutDir";
import { updateTabDataAction } from "@/store/workspacesTabsStoreACTIONS";

export interface EditableTextWorkspaceProps {
  initialText: string;
  tabNamesAndActiveData: IActiveTabData[];
  tabIdClickedOn: number;
  getAccessTokenSilently: Function;
  settingsConfigsFromStore?: IPriceConfigTab[];
  formCollapsedSidebar?: boolean;
  indexOfWorkspaceTab: number;
}

const EditableTextWorkspace: React.FC<EditableTextWorkspaceProps> = ({
  initialText,
  tabNamesAndActiveData,
  tabIdClickedOn,
  getAccessTokenSilently,
  formCollapsedSidebar = false,
  indexOfWorkspaceTab,
}) => {
  const [text, setText] = useState<string>(initialText);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>(initialText);

  useEffect(() => {
    setText(initialText);
    setInputValue(initialText); // If you also want inputValue to sync
  }, [initialText]);

  // locations to update stores.
  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    const newName = e.target.value; // settingsStore values will always be here as they are required to produce the data to create the component.
    const arrOfCurrentNames = tabNamesAndActiveData!.map(
      (config) => config.displayName,
    );

    if (arrOfCurrentNames.includes(newName) && newName != initialText) {
      setText(initialText);
      setInputValue(initialText);
      setIsEditing(false);
      toast.error("There is already a tab by that name.");
    } else {
      if (newName === "" || newName === undefined || newName === null) {
        setText(initialText);
        setInputValue(initialText);
        setIsEditing(false);
        toast.error("Empty input returned to original state.");
        return;
      }

      if (newName.length > 12) {
        setText(initialText);
        setInputValue(initialText);
        setIsEditing(false);
        toast.error("Input name can't be longer than 12 characters.");
        return;
      }
      setText(newName);
      //   updateInStoreAndDatabase(newName);
      const newJSONdataWithActiveTabs: IActiveTabData[] =
        tabNamesAndActiveData.map((tab) =>
          tab.tabId === tabIdClickedOn
            ? {
                ...tab,

                displayName: newName!,
              }
            : tab,
        );
      updateTabDataAction(newJSONdataWithActiveTabs, getAccessTokenSilently);
      setIsEditing(false);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleBlur(e as unknown as FocusEvent<HTMLInputElement>);
    }
  };

  return (
    <span
      className={`${formCollapsedSidebar ? "pl-1" : "pl-2"} flex w-full items-center `}
    >
      {isEditing ? (
        <input
          id={"workspaceInput" + indexOfWorkspaceTab}
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          autoFocus
          className="mr-1 flex w-full justify-start overflow-hidden bg-transparent pl-1"
        />
      ) : (
        <span
          className="mr-1 flex w-full justify-start overflow-hidden text-gray-500 dark:text-gray-200" // should be the same in SVG and Text Container.
          onDoubleClick={handleDoubleClick}
          id={"workspaceContainer" + indexOfWorkspaceTab}
        >
          {text}
        </span>
      )}
    </span>
  );
};

export default EditableTextWorkspace;
